import { render, staticRenderFns } from "./manage-calculation-parameters.component.vue?vue&type=template&id=b4ed1b68&scoped=true&"
import script from "./manage-calculation-parameters.component.vue?vue&type=script&lang=ts&"
export * from "./manage-calculation-parameters.component.vue?vue&type=script&lang=ts&"
import style0 from "./manage-calculation-parameters.component.vue?vue&type=style&index=0&id=b4ed1b68&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ed1b68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VForm,VIcon,VSelect,VTextField})
